import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import ModalSection from '../ModalSection';

import PromptModel from '../../../../models/PromptModel';
import FeaturesModelMC from '../../../../models/FeaturesModelMC';

import { SIDEBAR_ACTIONS } from '../../../../../constants/actionsConstants';
import RightModalLayout from '../../../../layouts/Modal/RightModalLayout';
import QuillComponent from '../QuillComponent';

const csrfToken = document.querySelector('[name=csrf-token]').content;

const BuyIntentionModal = ({ agentId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('ChatbotIA');

  const [content, setContent] = useState('');
  const [promptId, setPromptId] = useState(null);
  const [orderFlag, setOrderFlag] = useState(false);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    loadBuyIntention();
    loadFeatures();
  }, []);

  const toggleBuyIntentionModal = () => {
    dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
  };

  const loadBuyIntention = () => {
    if (!agentId) {
      showtoast(t('config.error_loading'));
      setLoading(false);
      return;
    }

    setLoading(true);
    PromptModel.get(agentId, { type: 'buy_intention' })
      .then((response) => {
        const prompts = response.data || [];
        const buyIntentionPrompt = prompts.find(p => p.type === 'buy_intention');

        if (buyIntentionPrompt) {
          setContent(buyIntentionPrompt.prompt || '');
          setPromptId(buyIntentionPrompt.id);
        } else {
          setContent('');
          setPromptId(null);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        showtoast(err.error || t('config.error_loading'));
      });
  };

  const loadFeatures = () => {
    FeaturesModelMC.getFeatures()
      .then((res) => {
        setFeatures(res.features);
      })
      .catch((err) => {
        showtoast(err.error || t('config.error_loading'));
      });
  }

  const updateInfo = (value) => {
    setContent(value);
  };

  const onSubmit = () => {
    if (!agentId) {
      showtoast(t('config.error_loading'));
      return;
    }

    setSaving(true);

    const promptParams = {
      prompt: content,
      type: 'buy_intention'
    };

    const savePromptPromise = promptId
      ? PromptModel.update(agentId, promptId, promptParams)
      : PromptModel.save(agentId, promptParams);

    savePromptPromise
      .then((result) => {
        if (!promptId && result?.id) {
          setPromptId(result.id);
        }
        setSaving(false);
        showtoast(t('config.save_success'));
        toggleBuyIntentionModal();
      })
      .catch((error) => {
        setSaving(false);
        showtoast(error.message || t('config.save_error'));
      });
  };

  // Commented out toggle-related code
  // const toggleOrderFlag = () => {
  //   setOrderFlag(!orderFlag);
  // };

  // const showOrderFlag = () => {
  //   const orderFeature = features.find(feature => feature.key === 'order_taking');
  //   if (orderFeature) {
  //     return orderFeature.enabled;
  //   }
  //   return true;
  // };

  return (
    <div className="tw-wrapper">
      <RightModalLayout
        title={t('config.buy_intention.modal_title')}
        submitAction={onSubmit}
        submitLabel={t('guides.sidebar_create.update')}
        submitDisabled={saving}
      >
        <ModalSection
          title={t('config.buy_intention.section_1_title')}
          description={t('config.buy_intention.section_1_description')}
          afterContent={(
            <QuillComponent
              name="buy_intention"
              value={content || ''}
              onChange={(value) => { updateInfo(value); }}
              placeholder={t('config.buy_intention.placeholder')}
              overflowHidden={false}
              style={{ height: '300px' }}
            />
          )}
        />

        {/* Commented out toggle-related UI */}
        {/* { showOrderFlag() && (
          <div className="tw-flex tw-flex-col tw-mt-4 px-5 pt-50">
            <ToggleSwitchMC
              isOn={orderFlag}
              handleToggle={toggleOrderFlag}
              label={t('config.buy_intention.order_taking_flag_title')}
              labelClassName="!tw-font-semibold"
            />
            <span className="tw-text-gray-950 tw-text-xs">{t('config.buy_intention.order_taking_flag_description')}</span>
          </div>
        )} */}
      </RightModalLayout>
    </div>
  );
};

export default BuyIntentionModal;
